import { useSelector } from 'react-redux';
import { USER_ROLE_KIND } from '../../types/User.types';
import { SharedReduxState } from '../../reducers/types';

export const useUserRole = () => {
  const userCompanies = useSelector(
    (state: SharedReduxState) => state.userCompanies
  );

  const getUserRoleKind = () => {
    return userCompanies?.current?.role_kind || null;
  };

  const hasRoleKinds = (roleKinds: USER_ROLE_KIND[]) => {
    const userKind = getUserRoleKind();
    return userKind && roleKinds.includes(userKind);
  };

  const isAdminUser = () => {
    const userKind = getUserRoleKind();
    return !!userKind && userKind === USER_ROLE_KIND.OH;
  };

  const getUserRole = () => {
    return userCompanies?.current?.role_name || null;
  };
  
  return {
    isAdminUser: isAdminUser(),
    hasRoleKinds,
    getUserRole
  };
};